
import * as ipxStaticRuntime$g7KXxX2eOli9GE_GO0B8GZxTGHd7G_455z13RYPmvbVdc from '/home/runner/work/site-movimento/site-movimento/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@8.2.0_db0@0.3.2_better-sqlite3@11.9.1__ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$g7KXxX2eOli9GE_GO0B8GZxTGHd7G_455z13RYPmvbVdc, defaults: {} }
}
        